import React from 'react';
import { Provider } from 'react-redux';
import { merge } from 'lodash';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { PurchaseMethods } from '@sm360/widget-commons-vehicle';
import { loadPurchaseMethods } from 'payment-calculator/actions/paymentCalculatorTestActions.js';
import configureStore from 'payment-calculator/store/configureStore.js';
import PaymentCalculator from 'payment-calculator/components/PaymentCalculator/PaymentCalculator.jsx';

import en from 'payment-calculator/i18n/en.json';
import fr from 'payment-calculator/i18n/fr.json';

const store = configureStore();

class PaymentCalculatorProvider extends React.Component {
    constructor() {
        super();

        store.dispatch(loadPurchaseMethods());

        merge(en, PurchaseMethods.Translations.en);
        merge(fr, PurchaseMethods.Translations.fr);

        LocaleService.setLocale('fr');
        LocaleService.loadTranslations({ en, fr });
    }

    render() {
        return (
            <Provider store={store}>
                <PaymentCalculator {...this.props} />
            </Provider>
        );
    }
}

export default PaymentCalculatorProvider;
